// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","715":"list","884":"admin"}[chunkId] || chunkId) + "." + {"594":"b646007a","612":"238544a4","715":"f89b6c0f","884":"732fb115"}[chunkId] + ".css";
};